<template>
    <div class="matting-control-el">
        <div class="matting-btns">
            <div class="btn cancel" @click.stop @mousedown.stop="cancel">取消</div>
            <div class="btn finish" :class="loading? 'gray': 'normal'" @click.stop @mousedown.stop="finish">完成</div>
        </div>
        <template v-if="loading">
            <div class="matting-shelter"></div>
            <div class="loadEffect"><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span></div>
        </template>
    </div>
</template>
<script type="text/javascript">
export default {
    name: 'matting',
    props: {
        loading: {
            type: Boolean,
            default: false,
        }
    },
    data () {
        return {
        }
    },
    methods: {
        cancel () {
            this.$emit('cancel');
        },
        finish () {
            if (this.loading) {
                return;
            }
            this.$emit('finish');
        }
    }
}
</script>
<style lang="scss">
.matting-control-el {
    width: 100%;
    height: 100%;
    left: 0!important;
    top: 0!important;
}
</style>


// WEBPACK FOOTER //
// src/components/tool/setPathAnim/matting.vue